export const TOGGLE_BUTTONS_TEXT = [
    {
        id: 0,
        name: 'basic',
    },
    {
        id: 1,
        name: 'child',
    },
    {
        id: 2,
        name: 'student',
    },
    {
        id: 3,
        name: 'senior',
    },
    {
        id: 4,
        name: 'ztp',
    },
]
